import "core-js/modules/es.error.cause.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * StackFrame entity. It contains information about parsed stack frame
 * with optional original source fileName, line, column and source if available.
 */
class StackFrame {
  constructor({
    rootDir,
    fileName,
    line,
    column,
    sourceFragment,
    functionName,
    orgFileName,
    orgLine,
    orgColumn,
    orgSourceFragment
  }) {
    _defineProperty(this, "rootDir", void 0);
    _defineProperty(this, "fileName", void 0);
    _defineProperty(this, "line", void 0);
    _defineProperty(this, "column", void 0);
    _defineProperty(this, "sourceFragment", void 0);
    _defineProperty(this, "functionName", void 0);
    _defineProperty(this, "orgFileName", void 0);
    _defineProperty(this, "orgLine", void 0);
    _defineProperty(this, "orgColumn", void 0);
    _defineProperty(this, "orgSourceFragment", void 0);
    this.rootDir = rootDir;
    this.fileName = fileName;
    this.line = line;
    this.column = column;
    this.sourceFragment = sourceFragment;
    this.functionName = functionName;
    this.orgFileName = orgFileName;
    this.orgLine = orgLine;
    this.orgColumn = orgColumn;
    this.orgSourceFragment = orgSourceFragment;
  }

  /**
   * Returns the name of stack frame function.
   *
   * @returns {string} Name of the function (anonymous) if unavailable.
   */
  getFunctionName() {
    return this.functionName || '(anonymous function)';
  }

  /**
   * Returns the file name at originalFileName path
   *
   * @returns {string} Name of the file (after last slash).
   */
  getPrettyFileName() {
    return this.orgFileName?.split('/').pop() ?? '(unable to parse filename)';
  }

  /**
   * Return original fileUri stripped of path prefixes.
   *
   * @returns {string|undefined}
   */
  getPrettyOriginalFileUri() {
    const strippedUri = this.orgFileName?.replace(/^(webpack:\/\/|webpack-internal:\/\/\/)/gi, '');
    const indexOfFirstSlash = strippedUri?.indexOf('/');

    // Print paths relative to app dir
    if (indexOfFirstSlash) {
      return `./${strippedUri?.substring(indexOfFirstSlash + 1)}`;
    }
    if (this.rootDir) {
      return strippedUri?.replace(this.rootDir, '.');
    }
    return strippedUri;
  }
}
export { StackFrame };